<div class="nav-wizards-container">
    <nav class="nav nav-wizards-1 mb-2">
      <!-- completed -->
      <div class="nav-item col">
        <a class="nav-link" [ngClass]="{'completed':step>0,'active':step==0}" href="#">
          <div class="nav-no">1</div>
          <div class="nav-text">Welcome</div>
        </a>
      </div>
    
      <!-- active -->
      <div class="nav-item col">
        <a class="nav-link" [ngClass]="{'completed':step>1,'active':step==1}" href="#">
          <div class="nav-no">2</div>
          <div class="nav-text">Review Information</div>
        </a>
      </div>
    
      <!-- active -->
      <div class="nav-item col">
        <a class="nav-link" [ngClass]="{'completed':step>2,'active':step==2}" href="#">
          <div class="nav-no">3</div>
          <div class="nav-text">Terms of Service</div>
        </a>
      </div>
    
      <!-- disabled -->
      <div class="nav-item col">
        <a class="nav-link disabled" href="#">
          <div class="nav-no">4</div>
          <div class="nav-text">Go</div>
        </a>
      </div>
    </nav>
  </div>
  
  <div class="card">
    <div class="card-body">
      
        <main id="onboarding-wrapper" [ngSwitch]="step">
            <!-- Step 0 -->
            <section class="onboarding-step" *ngSwitchCase="0">
                <!-- Header -->
                <div class="step-header">
                    <h1>Welcome to Indicium Cloud</h1>
                </div>
                <!-- Body -->
                <div class="step-body">
                    <div *ngIf="config.settings" [innerHtml]="config.settings.welcome"></div>
                </div>
                <!-- Footer -->
                <div class="step-footer">
                    <div class="step-footer-right">
                        <button class="btn btn-primary btn-lg" (click)="step = 1">Next</button>
                    </div>
                </div>
            </section>
            <!-- Step 1 -->
            <section class="onboarding-step" *ngSwitchCase="1">
                <!-- Header -->
                <div class="step-header">
                    <h2>Review Information</h2>
                </div>
                <!-- Body -->
                <div class="step-body">
                    <!-- Form -->
                    <form class="onboarding-form" [formGroup]="onboardingGroupModel ">
                        <!-- User Full Name -->
                        <div class="form-group mb-3" >
                            <label class="form-label">Full Name</label>
                            <input class="form-control" autocomplete="off" type="text" formControlName="fullName" [class.is-valid]="!onboardingGroupModel.controls['fullName'].invalid" [class.is-invalid]="onboardingGroupModel.controls['fullName'].invalid && onboardingGroupModel.controls['fullName'].touched">
                        </div>
                        <!-- User Company Name -->
                        <div class="form-group mb-3">
                            <label class="form-label">Contact Email Address</label>
                            <input class="form-control" autocomplete="off" type="text" formControlName="emailAddress" 
                                [class.is-valid]="!onboardingGroupModel.controls['emailAddress'].invalid && onboardingGroupModel.controls['emailAddress'].touched" 
                                [class.is-invalid]="onboardingGroupModel.controls['emailAddress'].invalid && onboardingGroupModel.controls['emailAddress'].touched">
                            <div class="invalid-feedback" *ngIf="onboardingGroupModel.controls['emailAddress'].invalid">Valid email address required </div>
                        </div>
                        <!-- User Company Telephone -->
                        <div class="form-group">
                            <label class="form-label">Mobile Number</label>
                            <input class="form-control" autocomplete="off" type="tel" formControlName="mobileNumber"
                                [class.is-valid]="!onboardingGroupModel.controls['mobileNumber'].invalid" 
                                [class.is-invalid]="onboardingGroupModel.controls['mobileNumber'].invalid && onboardingGroupModel.controls['mobileNumber'].touched">
                            <div class="invalid-feedback" *ngIf="onboardingGroupModel.controls['mobileNumber'].invalid">Valid mobile number required </div>
                        </div> 
                    </form>
                </div>
                <!-- Footer -->
                <div class="step-footer">
                    <div class="step-footer-left">
                        <button class="btn btn-default btn-lg" (click)="step = 0">Previous</button>
                    </div>
                    <div class="step-footer-right">
                        <button class="btn btn-primary btn-lg" [disabled]="onboardingGroupModel.invalid" (click)="step = 2">Next</button>
                    </div>
                </div>
            </section>
            <!-- Step 2 -->
            <section class="onboarding-step" *ngSwitchCase="2">
                <!-- Header -->
                <div class="step-header">
                    <h1>Terms of Service</h1>
                </div>
                <!-- Body -->
                <div class="step-body">
                    <div class="onboarding-tos">
                        <div class="onboarding-tos-content">
                            
        
                            <div *ngIf="config.settings" [innerHtml]="config.settings.agreement"></div>
        
                        </div>
                    </div>
                    <div class="form-group">
                        <label>
                            <input type="checkbox" [(ngModel)]="acceptedTerms">
                            I agree to the above terms and conditions
                        </label>
                    </div>
                </div>
                <!-- Footer -->
                <div class="step-footer">
                    <div class="step-footer-left">
                        <button class="btn btn-default btn-lg" (click)="step = 1">Previous</button>
                    </div>
                    <div class="step-footer-right">
                        <button class="btn btn-primary btn-lg" [disabled]="!acceptedTerms" (click)="submitOnboarding()">Submit</button>
                    </div>
                </div>
            </section>
        </main>


    </div>
  </div>

